import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-parameters',
  templateUrl: './edit-parameters.component.html',
  styleUrls: ['./edit-parameters.component.css']
})
export class EditParametersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
